import React from "react";
import clsx from "clsx";
import { PrimaryButton } from "../PrimaryButton";

import * as styles from "./index.module.scss";

export const SecondaryButton = React.forwardRef(
  ({ children, className, purple = false, ...props }, ref) => {
    return (
      <PrimaryButton
        className={clsx(
          className,
          styles.secondaryButton,
          purple && styles.purple,
        )}
        ref={ref}
        {...props}
      >
        {children}
      </PrimaryButton>
    );
  },
);

SecondaryButton.displayName = "SecondaryButton";
